










import Vue from 'vue'
import { RoamingCountryPickerElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'RoamingCountryPickerEl',
  data: () => ({
    country: ''
  }),
  props: {
    templateItemData: {
      type: Object as () => RoamingCountryPickerElInterface,
      required: true
    }
  },
  computed: {
    countries (): Array<Record<string, string>> {
      const countries: Array<Record<string, string>> = []

      this.templateItemData.countries.forEach((country) => {
        countries.push({
          text: country.val,
          value: country.key
        })
      })

      return countries
    }
  },
  methods: {
    sendRequest () {
      this.$axios.post(
        this.templateItemData.uri,
        {
          id: this.templateItemData.id,
          country: this.country
        }
      )
        .then(res => {
          this.getView(this.templateItemData.view, res.data.data.uri)
        })
        .catch(() => { /* do nothing */ })
    }
  },
  mounted () {
    this.country = this.templateItemData.value
  }
})
